import React from 'react';
import { css, useTheme } from '@emotion/react';
import { type RestModalInfo } from '@bbkAdminUtils/api-client/rest-modals-cards-types';
import { cs } from '@bbkAdminUtils/css-utils';
import { type EmotionTheme } from '@bbkFunnel/pages/theme';
import CustomerHtml from '@bbkFunnelComponents/customer_html/customer_html';

type Props = {
  info: RestModalInfo;
  headlineBig?: boolean;
};
const ModalTitle: React.FC<Props> = ({ info, headlineBig }) => {
  const theme = useTheme() as EmotionTheme;

  const baseStyles = css({
    paddingBottom: '16px',
    fontWeight: 'bold',
    fontSize: headlineBig ? '2.44rem' : '2rem',
    lineHeight: '44px',
  });

  const titleThemeStyles = css({
    color: theme.titleFontColor || theme.primaryColor,
    fontWeight: theme.titleFontWeight,
    fontSize:
      headlineBig && theme.titleFontSize
        ? `calc(${theme.titleFontSize}+.3rem)`
        : theme.titleFontSize,
    fontFamily: theme.titleFontFamily,
    textTransform: theme.titleTextTransform,
  });

  return (
    <div className="modal-title">
      <div className="MTContainer" id="MTContainer">
        {info.offer && <div className="offer">{info.offer}</div>}
        <div className="preheadline">{info.headline}</div>
        <div
          className={cs('headline', { headlineBig })}
          css={[baseStyles, titleThemeStyles]}
        >
          <CustomerHtml value={info.title} />
        </div>
        <div className="subheader">
          <span className="tip-text">
            <CustomerHtml value={info.details} />
          </span>
        </div>
      </div>
    </div>
  );
};

export default ModalTitle;
